import styled from 'styled-components/macro';


export const StyledNav = styled.nav`
    display:flex;
    justify-content:space-between;
    flex-wrap:wrap;
    width:100%;
    height:100%;
`;

